import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export default function DetailsTile({
  children,
  className,
}: Readonly<{
  children: ReactNode;
  className?: string;
}>) {
  return (
    <div
      className={twMerge(
        'h-fit rounded-xl border border-neutral-5/40 bg-white px-4 py-6 shadow-nuki-blured sm:px-6 sm:py-8',
        className,
      )}
    >
      {children}
    </div>
  );
}
